import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {G2ReviewMeta, G2ReviewMetaAggregate, G2ReviewMetaAggregateCollection} from '../../../models/g2-review.model';

@Component({
  selector: 'dcp-review-summary',
  templateUrl: './review-summary.component.html',
  styleUrls: ['./review-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReviewSummaryComponent implements OnInit {


  @Input() g2Meta: G2ReviewMeta;
  @Input() infoText: string;
  @Input() ctaText: string;
  public npsScore: G2ReviewMetaAggregate;
  totalScoreCount: number;


  ngOnInit() {
    this.npsScore = this.g2Meta.aggregates.find(a => a.filter_name === 'nps_score');
    this.totalScoreCount = this.calcTotalScoreCount(this.npsScore);
  }

  calcTotalScoreCount(npsScores: G2ReviewMetaAggregate): number {
    let totalScoreCount: number = 0;
    for (const score of npsScores.collection) {
      totalScoreCount += score.count;
    }
    return totalScoreCount;
  }

  calcScorePercentage(score: G2ReviewMetaAggregateCollection) {
    return Math.round((score.count / this.totalScoreCount) * 100);
  }
}
